export default __webpack_public_path__ + "static/media/logo-whats.3ee0d379.png";